(function ($) {

    var $body = $('body');

    $(document).ready(function () {
        var $delayedFocus = $('[data-delayed-focus]');

        if ($delayedFocus.length !== 1) {
            return;
        }

        setTimeout(function () {
            $delayedFocus.select();
        }, $delayedFocus.data('delayed-focus'));
    });

})(require('jquery'));
